export enum EndPoints {
  Login = 'Account/Login',
  GetStocks = 'Stockv1/GetStocks',
  CreateStock = 'StockV1/CreateStock',
  UpdateStock = 'StockV1/UpdateStock',
  DeleteStock = 'StockV1/DeleteStock',
  DeleteStockPart = 'StockV1/DeleteStockPart',
  UpdateStockLocation = 'StockV1/UpdateStockLocation',
  ValidateStockName = 'StockV1/ValidateStockName',
  GetCustomerDropdown = 'AssignmentV1/GetCustomerDropdown',
  GetCustomerInvoiceDropdown = 'AssignmentV1/GetCustomerInvoiceDropdown',
  GetStockDropdown = 'AssignmentV1/GetStockDropdown',
  GetStockDropdownWithQty = 'AssignmentV1/GetStockDropdownWithQty',
  GetStockPartDropdown = 'AssignmentV1/GetStockPartDropdown',
  GetAssignments = 'AssignmentV1/GetAssignments',
  CreateAssignment = 'AssignmentV1/CreateAssignment',
  DeleteAssignment = 'AssignmentV1/DeleteAssignment',
  DeleteAssignmentStock = 'AssignmentV1/DeleteAssignmentStock',
  DeleteAssignmentPartNumber = 'AssignmentV1/DeleteAssignmentPartNumber',
  AddAssignmentStock = 'AssignmentV1/AddAssignmentStock',
  GetAssignmentDetailsById = 'Assignment/GetAssignmentDetailsById',
  // GetStatus = 'GetStatus',
  GetStatusV1 = 'GetStatusV1',
  GetInvoiceAmount = 'GetInvoiceAmount',
  UpdateCalledStatus = 'UpdateCalledStatus',
  GetPartNumbers = 'StockV1/GetPartNumbers',
  DashboardData = 'Dashboard/DashboardData',
  GetPartNumberAssignmentDetail = 'Dashboard/GetPartNumberAssignmentDetail',
  GetN2OPartNumberAssignmentDetail = 'Dashboard/GetN2OPartNumberAssignmentDetail',
  UpdateN2OAssignnmentStocksDetail = 'Dashboard/UpdateN2OAssignnmentStocksDetail',
  UpdateStockAsArchive = 'StockV1/UpdateStockAsArchive',
  GetAuditLog = 'AuditLog/GetAuditLog',
  ImportStock = 'StockV1/ImportStock',
  TransferPartNumber = 'StockV1/TransferPartNumber',
  SaveAssignmentNotes = 'AssignmentV1/SaveAssignmentNotes',
  SyncLatestCustomers = 'AssignmentV1/SyncLatestCustomers',
  SyncLatestInvoices = 'AssignmentV1/SyncLatestInvoices',
  UpdateShippedDateAndStatus = 'UpdateShippedDateAndStatus',
  GetPartNumberDetail = 'StockV1/GetPartNumberDetail',
  GetWareHouseStocks = 'Warehouse/GetWareHouseStocks',
  GetAssignmentDetails = 'Warehouse/GetAssignmentDetails',
  SaveWarehouseStock = 'Warehouse/SaveWarehouseStock',
  DownloadPhysicalInventoryTemplate = 'Warehouse/DownloadPhysicalInventoryTemplate',
  ConvertWayfairCSVFile = 'Warehouse/ConvertWayfairCSVFile',
  ImportPhysicalInventoryFile = 'Warehouse/ImportPhysicalInventoryFile',
  GetStockAssignmentDetailV1 = 'AssignmentV1/GetStockAssignmentDetail',
  GetAssignmentStock = 'AssignmentV1/GetAssignmentStock',
  GetEditAssignmentStocksDetail = 'AssignmentV1/GetEditAssignmentStocksDetail',
  UpdateShippedStatus = 'UpdateShippedStatus',
  UpdatePartNumber = 'StockV1/UpdatePartNumber',
  GetLatestCreatedInvoices = 'AssignmentV1/GetLatestCreatedInvocies',
  GetInvoiceByNumber = 'AssignmentV1/GetInvoiceByNumber',
  GetStockAssignmentDetail = 'Dashboard/GetStockAssignmentDetail',
  GetN2OStockAssignmentDetail = 'Dashboard/GetN2OStockAssignmentDetail',
  ValidateAssignmentStock = 'AssignmentV1/ValidateAssignmentStock',
  GetAssignmentByInvoiceNumber = 'AssignmentV1/GetAssignmentByInvoiceNumber',
  ExpandAllPartnumber = 'AssignmentV1/ExpandAllPartnumber',
  GetLastMonthUnAssignInvoices = 'AssignmentV1/GetLastMonthUnAssignInvoices',

  GetUncompletedStatus = 'GetUnCompletedStatus',
  GetUncompletedStatusCount = 'GetUnCompletedStatusCount',
  GetAfterShipStatus = 'GetAfterShipStatus',
  AfterShipManualSync = 'AfterShipManualSync',

  //get integration status
  GetRouteIntegrationStatus = 'GetRouteIntegrationStatus',

  //sync dashboard (Phase 22)
  GetSyncConnectorHealth = 'GetSyncConnectorHealth',
  GetSyncActivity = 'GetSyncActivity',
  GetSyncActivityDetail = 'GetSyncActivityDetail',

  //qbinvoice
  DeleteQuickBookInvoice = 'api/Orders/DeleteQuickBookInvoice',
  UpdateWoocommerceOrderStatus = 'api/Orders/UpdateWoocommerceOrderStatus',

  //enhancement
  QBOCallBack = 'api/QBOConnection/QBOCallBack',
  GetQBOAuthDetail = 'api/QBOConnection/GetQBOAuthDetail',
  QBOAuthConnectionTest = 'api/QBOConnection/QBOAuthConnectionTest',
  RevokeQBOAuthDetail = 'api/QBOConnection/RevokeQBOAuthDetail',
  CheckServiceStatus = 'api/QBOConnection/CheckServiceStatus',
  StartWindowService = 'api/QBOConnection/StartWindowService',
  ShopifyCallBack = 'api/ShopifyConnection/ShopifyCallBack',
  GetShopifyAuthDetail = 'api/ShopifyConnection/GetShopifyAuthDetail',
  ShopifyAuthConnectionTest = 'api/ShopifyConnection/ShopifyAuthConnectionTest',
  RevokeShopifyAuthDetail = 'api/ShopifyConnection/RevokeShopifyAuthDetail',
  GetShopifyConnectionConfig = 'api/ShopifyConnection/GetShopifyConnectionConfig',
  ShopifyRegisterWebhooks = 'api/ShopifyWebhook/RegisterWebhooks',
  ShopifyDeregisterWebhooks = 'api/ShopifyWebhook/DeregisterWebhooks',
  ShopifyGetWebhooks = 'api/ShopifyWebhook/Webhooks',
  SyncRetailPrices = 'ShopifyPriceSync/SyncRetailPrices',

  GetOrdersQBO = 'api/Orders/GetOrdersQBO',
  GetOrdersWoocommerce = 'api/Orders/GetOrdersWoocommerce',
  GetOrdersWayfair = 'api/Orders/GetOrdersWayfair',
  GetOrdersShopify = 'api/Orders/GetOrdersShopify',
  ManualSyncShopifyOrder = 'api/Orders/ManualSyncShopifyOrder',
  ManualSyncQBOInvoice = 'api/Orders/ManualSyncQBOInvoice',
  ImportPart = 'api/Part/ImportPart',

  //qbo webhook
  QBOWebhookCallBack = 'api/QBOWebhook/QBOWebhookCallBack',

  //Shipped
  GetShippedData = 'api/ShippedReturn/GetShippedData',
  UpdateShippedReturnStatus = 'api/ShippedReturn/UpdateShippedReturnStatus',
  GetReturnAssignmentsData = 'api/ShippedReturn/GetReturnAssignmentsData',
  UpdateReturnTrackingNumber = 'api/ShippedReturn/UpdateReturnTrackingNumber',
  UpdateDamagedAndB2SStatus = 'api/ShippedReturn/UpdateDamagedAndB2SStatus',



}

export enum ResponseStatus {
  Unauthorized = 401,
  NotFound = 400,
  Success = 200,
  Error = 500,
}

export enum ResponseMessageStatus {
  info = 'info',
  warning = 'warning',
  success = 'success',
  error = 'error',
  loading = 'loading',
}

export enum ResultStatus {
  NoProcess = 0,
  Failure = 1,
  Abort = 2,
  Cancel = 3,
  Warning = 4,
  Information = 5,
  NoData = 6,
  Validation = 7,
  Success = 8,
}

export enum StockLocation {
  OnProduction = 1,
  OnWater = 2,
  InWarehouse = 3,
}

export enum SortBy {
  Asc = 0,
  Dsc = 1,
}

export enum EntityType {
  Stock = 1,
  Assignment = 2,
  Status = 3,
  warehouse = 4,
}

export class CSVRecord {
  public partNumber: any;
  public quantity: any;
  public physicalStock: any;
  public different: any;
  public comment: any;
}
